module.exports = __webpack_public_path__ + "static/vision-image-491d1de8f65c88b5314d57d912172e0a.jpg";